import { Component, Element, h, State } from '@stencil/core';
import { extractLabels } from '~service/translation-service';

declare const TYPO3: any;

@Component({
  tag: 'mama-form-textarea',
  styleUrl: './mama-form-textarea.scss',
})
export class MamaFormTextarea {
  @Element() el: HTMLElement;

  label: HTMLLabelElement;
  textarea: HTMLTextAreaElement;
  maxlength: number = 2000;
  required: boolean = false;

  @State() internalValue: string = '';
  @State() isInvalid: boolean = false;
  @State() displayErrorMessage: string = '';
  @State() inputlength: number = 0;

  private errorLabels = {
    'form.error.required': 'Das ist ein Pflichtfeld',
  };

  componentWillLoad() {
    this.textarea = this.el.querySelector('textarea');
    this.label = this.el.querySelector('label');
    this.required = this.textarea.required;

    this.internalValue = this.textarea.value;

    if (this.textarea.classList.contains('error')) {
      this.textarea.classList.remove('error');
      this.isInvalid = true;
    }
  }

  componentDidLoad() {
    this.errorLabels = { ...this.errorLabels, ...extractLabels() };
    this.setFocusClass();
    this.registerEventListeners();
  }

  registerEventListeners() {
    this.textarea.addEventListener('focus', () => {
      this.handleFocusChange();
    });
    this.textarea.addEventListener('blur', () => {
      this.handleBlurChange();
    });
    this.textarea.addEventListener('change', event => {
      this.handleValueChange(event);
    });
    this.textarea.addEventListener('input', event => {
      this.handleKeyDownChange(event);
    });
  }

  setFocusClass() {
    if (this.internalValue !== '') {
      this.el.classList.add('focus');
    }
  }

  validate() {
    if (this.required) {
      this.isInvalid = this.internalValue === '';
      if (this.isInvalid) {
        this.displayErrorMessage = this.errorLabels['form.error.required'];
      }
    }
  }

  handleValueChange(event) {
    if (this.inputlength <= this.maxlength) {
      this.internalValue = event.target.value;
      this.setFocusClass();
      this.validate();
    }
  }

  handleKeyDownChange(event) {
    if (event.target.value.length > this.maxlength) {
      this.inputlength = this.maxlength;
      this.el.querySelector('textarea').value = this.internalValue;
    } else {
      this.internalValue = event.target.value;
      this.inputlength = event.target.value.length;
    }
  }

  handleFocusChange() {
    this.el.classList.add('focus');
  }

  handleBlurChange() {
    if (this.internalValue === '') {
      this.el.classList.remove('focus');
    }
  }

  hostData() {
    return {
      class: {
        'is-invalid': this.isInvalid,
      },
    };
  }

  render() {
    return [
      <slot />,
      <div class="counter">
        {this.inputlength}/{this.maxlength}
      </div>,
      <div class="invalid-feedback">{this.displayErrorMessage}</div>,
    ];
  }
}
